import React from "react";
import { useDispatch } from "react-redux";
import { backButtonHandler } from "../../Redux/actions";
let BtmButtons = ({ submitHandler }) => {
  const dispatch = useDispatch();
  return (
    <div class="btns row justify-content-end mx-0 px-3 pb-0">
      <button
        id="back"
        name="back"
        class="col-sm-1 mx-0"
        type="button"
        onClick={() => dispatch(backButtonHandler())}
      >
        Back
      </button>
      <button
        id="saveTemplate"
        class="btn bordered-btn mx-4 col-sm-1"
        type="button"
        onClick={() => submitHandler(true)}
      >
        Save{" "}
      </button>
      <button
        id="next"
        class="btn_btnblue mx-0 col-sm-1"
        type="button"
        onClick={() => submitHandler()}
      >
        Next Step{" "}
      </button>
    </div>
  );
};
export default BtmButtons;
